import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
  fetchVouchers: ['filter', 'offset', 'shouldShowError'],
  fetchVouchersListLoading: null,
  fetchVouchersListSuccess: ['offset', 'vouchers', 'nextOffset', 'newVoucher'],
  fetchVouchersListError: ['error'],
  setVouchersFilter: ['newFilter'],
  clearVouchersFilter: ['admin'],
  clearVouchers: null,

  addVoucher: ['voucher'],
  addVoucherLoading: null,
  addVoucherSuccess: ['voucher'],
  addVoucherFail: ['error'],

  updateVoucher: ['voucherId', 'newVoucher', 'index', 'onResponse'],
  updateVoucherLoading: null,
  updateVoucherSuccess: ['index', 'newVoucher'],
  updateVoucherFail: ['error'],

  deleteVoucher: ['voucherId'],
  deleteVoucherLoading: null,
  deleteVoucherSuccess: ['voucherId'],
  deleteVoucherFail: ['error'],

  fetchVouchersCount: ['filter'],
  fetchVouchersCountLoading: null,
  fetchVouchersCountSuccess: ['vouchersCount'],
  fetchVouchersCountFail: ['error'],

  fetchAllVouchers: ['offset', 'voucherName'],
  fetchAllVouchersLoading: null,
  fetchAllVouchersSuccess: ['offset', 'vouchers', 'nextOffset'],
  fetchAllVouchersFail: ['error'],

  setUpdateVoucherRequestState: ['newState'],
  setAddVoucherRequestState: ['newState'],
})

export const VoucherTypes = Types
export default Creators
